/* eslint-disable */

import $ from 'jquery';
import FacebookService from './facebook_service';
import GoogleService from '~/app/javascript/src/services/google_service';

export const ERROR_ACCOUNT_SUSPENDED = 0;
export const ERROR_ALREADY_FACEBOOK_USER = 1;
export const ERROR_ALREADY_GOOGLE_USER = 2;
export const ERROR_EMAIL_NOT_FOUND = 3;
export const ERROR_FACEBOOK_BAD_RESPONSE = 4;
export const ERROR_FACEBOOK_NOT_AUTHORIZED = 5;
export const ERROR_GENERIC = 6;
export const ERROR_INVALID_LOGIN = 7;
export const ERROR_PASSWORD_TOO_SHORT = 8;

const SERVER_ERROR_GENERIC = 0; // eslint-disable-line
const SERVER_ERROR_BAD_REQUEST = 1; // eslint-disable-line
const SERVER_ERROR_WRONG_CREDENTIALS = 2; // eslint-disable-line
const SERVER_ERROR_ACCOUNT_SUSPENDED = 3;
const SERVER_ERROR_PASSWORD_TOO_SHORT = 8;
const SERVER_ERROR_INEXISTENT_USER = 4; // eslint-disable-line

class LoginService {
  static register(loginData) {
    return new Promise((resolve, reject) => {
      $.post('/api/qb/v1/auth/register', loginData).then(resolve, (error) => {
        const message = error.responseText.toLowerCase();
        const isFacebookLogin = message.includes('conta já vinculada, entre com o facebook');
        const isGoogleLogin = message.includes('conta já vinculada, entre com o google');

        if (isFacebookLogin) {
          return reject({
            error,
            code: ERROR_ALREADY_FACEBOOK_USER,
          });
        }

        if (isGoogleLogin) {
          return reject({
            error,
            code: ERROR_ALREADY_GOOGLE_USER,
          });
        }

        switch (error.status) {
          case 401:
          case 403: {
            const errorCode = error.responseJSON.error_code;

            switch (errorCode) {
              case SERVER_ERROR_ACCOUNT_SUSPENDED: {
                return reject({
                  error,
                  code: ERROR_ACCOUNT_SUSPENDED,
                });
              }
              case SERVER_ERROR_PASSWORD_TOO_SHORT: {
                return reject({
                  error,
                  code: ERROR_PASSWORD_TOO_SHORT,
                });
              }
              default: {
                return reject({
                  error,
                  code: ERROR_INVALID_LOGIN,
                });
              }
            }
          }
          default: {
            return reject({
              error,
              code: ERROR_GENERIC,
            });
          }
        }
      });
    });
  }

  static login(loginData) {
    return new Promise((resolve, reject) => {
      $.post('/api/qb/v1/auth/login', loginData).then(resolve, (error) => {
        switch (error.status) {
          case 401:
          case 403: {
            const errorCode = error.responseJSON.error_code;

            switch (errorCode) {
              case SERVER_ERROR_ACCOUNT_SUSPENDED: {
                return reject({
                  error,
                  code: ERROR_ACCOUNT_SUSPENDED,
                });
              }
              default: {
                return reject({
                  error,
                  code: ERROR_INVALID_LOGIN,
                });
              }
            }
          }
          default: {
            return reject({
              error,
              code: ERROR_GENERIC,
            });
          }
        }
      });
    });
  }

  static recover(data) {
    return new Promise((resolve, reject) => {
      $.post('/api/qb/v1/auth/recovery', data).then(resolve, (error) => {
        switch (error.status) {
          case 403: {
            const message = error.responseText.toLowerCase();
            const isAccountSuspended = message.includes('a conta foi suspensa, entre em contato conosco');

            if (isAccountSuspended) {
              return reject({
                error,
                code: ERROR_ACCOUNT_SUSPENDED,
              });
            }

            return reject({
              error,
              code: ERROR_EMAIL_NOT_FOUND,
            });
          }
          default: {
            return reject({
              error,
              code: ERROR_GENERIC,
            });
          }
        }
      });
    });
  }

  static fbLogin(scope) {
    return FacebookService.loadSdk().then((FB) => {
      return new Promise((resolve, reject) => {
        FB.login((resp) => {
          const { authResponse, status } = resp;

          switch (status) {
            case 'connected': {
              const params = {
                uid: authResponse.userID,
                code: authResponse.accessToken,
              };
              return $.get('/api/qb/v1/auth/fb-login', params).done(resolve).fail((error) => {
                reject({
                  error,
                  code: ERROR_GENERIC,
                });
              });
            }
            case 'authorization_expired':
            case 'not_authorized': {
              return reject({
                code: ERROR_FACEBOOK_NOT_AUTHORIZED,
                facebookResponse: resp,
              });
            }
            case 'unknown': {
              return reject({
                code: ERROR_FACEBOOK_BAD_RESPONSE,
                facebookResponse: resp,
              });
            }
            default: {
              return reject({
                code: ERROR_GENERIC,
                facebookResponse: resp,
              });
            }
          }
        }, { scope });
      });
    });
  }

  static googleLogin() {
    return GoogleService.loadSdk().then((gapi) => {
      // TODO: Tratar casos de erro
      const googleAuth = gapi.auth2.getAuthInstance();
      return googleAuth.signIn().then((googleUser) => {
        return new Promise((resolve, reject) => {
          $.post('/api/qb/v1/auth/google-login', {
            token: googleUser.getAuthResponse().id_token,
          }).done(resolve).fail(reject);
        });
      });
    });
  }
}

export default LoginService;
